// context is default state passed from Magento
// and merged with state returned by Node
// for details check ./index.ssr.js and Neuca_Frontend/app/design/frontend/neuca/default/template/macopedia/catalog/catalog.phtml

export const CONTEXT = new Proxy(
    // eslint-disable-next-line no-undef
    typeof __CONTEXT__ !== 'undefined' ? __CONTEXT__ : {},
    {
        get(target, name, receiver) {
            if (!Reflect.has(target, name)) {
                return undefined
            }
            return Reflect.get(target, name, receiver)
        },
        set(target, name, value, receiver) {
            return Reflect.set(target, name, value, receiver)
        }
    }
)

const contextPlugin = {
    install(Vue) {
        Vue.prototype.$context = CONTEXT
    }
}

export default contextPlugin
